<template>
  <div id="app">
    <nav-header></nav-header>
    <router-view v-if="isRouterAlive"></router-view>
    <nav-footer></nav-footer>
  </div>
</template>

<script>
import Vue from "vue"
import navHeader from "./components/nav-header/index"
import navFooter from "./components/nav-footer/index"
export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  components: {
    "nav-header": navHeader,
    "nav-footer": navFooter
  },
  created: function () {
    // 服务器地址
    // Vue.prototype.serverSrc = "https://app.zhengshangyun.cn"
    Vue.prototype.serverSrc = "http://app.zhengshangyun.cn"
    // 接口地址
    // Vue.prototype.apiSrc = "https://api.zhengshangyun.cn"
    Vue.prototype.apiSrc = "http://api.zhengshangyun.cn"
  },
  methods: {
    reload: function () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
}
</script>

<style>
@import "./assets/css/public.css";
@import "./assets/css/base.css";
@import "./assets/fonts/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/App.vue